import CheckboxSelectionProcessor from '../../Components/Core/Processors/CheckboxSelectionProcessor'
import CheckBoxSelectionResultProcessor from '../../Components/Core/SelectionResults/CheckBoxSelectionResultProcessor'
import FirstFourValidator from '../../Validation/FirstFourValidator'
import BetTypeInformation from '../Betting/BetTypeInformation'
import type { IConfigureBetType } from './IConfigureBetType'

export default class FirstFourConfigurator implements IConfigureBetType {
  build(): BetTypeInformation {
    return new BetTypeInformation({
      betType: 'First4',
      name: 'First 4',
      supportsFlexi: true,
      sortOptions: ['Number', 'FixedPrice', 'Price'],
      template: 'first4-template',
      betSelectionTemplate: 'quad-checkbox-selection-template',
      multiBet: false,
      multiSelections: true,
      checkBoxCount: 4,
      fieldCheckBoxCount: 4,
      sameAsCheckBoxCount: 3,
      processor: new CheckboxSelectionProcessor(4),
      validator: new FirstFourValidator(),
      selectionResultProcessor: new CheckBoxSelectionResultProcessor(4),
      legs: 1,
    })
  }
}
